import { TranslateService } from '@ngx-translate/core';

const missingFieldLabels: Record<string, string[]> = {
  lines: ['CRM.CONTRACT.SERVICES'],
  dates: ['CRM.CONTRACT.START_DATE', 'CRM.CONTRACT.DURATION'],
  installments: ['CRM.FINANCIAL.INSTALLMENTS'],
  commercial_name: ['CRM.CUSTOMERS.COMMERCIAL_NAME'],
  commercial_registration_number: ['CRM.CUSTOMERS.CR_NUMBER'],
  tax_number: ['CRM.CUSTOMERS.TAX_NUMBER'],
  national_address: ['CRM.CUSTOMERS.NATIONAL_ADDRESS'],
};

/** Translate the server's rule code and missing-field identifiers without reimplementing validation. */
export function crmErrorMessage(
  payload: { error_code?: unknown; message?: unknown; missing?: unknown } | null | undefined,
  translate: Pick<TranslateService, 'instant' | 'currentLang'>,
): { title: string; text: string } | null {
  const code = payload?.error_code;
  if (typeof code !== 'string' || !code.startsWith('CRM_')) {
    return null;
  }
  // The server message follows Accept-Language and names what is wrong; the code text is the fallback (PF-0157, PF-0178).
  const serverMessage = typeof payload?.message === 'string' ? payload.message.trim() : '';
  if (serverMessage) {
    return { title: serverMessage, text: '' };
  }
  const key = 'ERROR_CODES.' + code;
  const title = translate.instant(key);
  if (typeof title !== 'string' || title === key) {
    return null;
  }

  let text = '';
  if (code === 'CRM_CONTRACT_INCOMPLETE' && Array.isArray(payload?.missing)) {
    const keys = payload.missing.flatMap((field: unknown) =>
      typeof field === 'string' && Object.hasOwn(missingFieldLabels, field) ? missingFieldLabels[field] : [],
    );
    const fields = [...new Set(keys)].map((label) => translate.instant(label));
    if (fields.length > 0) {
      text = translate.instant('CRM.CONTRACT.MISSING_REQUIRED', {
        fields: fields.join(translate.currentLang?.startsWith('ar') ? '، ' : ', '),
      });
    }
  }

  return { title, text };
}
